// src/store/features/ui/uiSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  // Sidebar & Theme
  isSidebarOpen: false,
  isDarkMode: false,

  // Input Bar
  isInputFocused: false,
  isInputDisabled: false,
  inputPlaceholder: "",
  inputValue: "",
  isTyping: false,

  // Send Button
  sendButtonLoading: false,
  sendButtonDisabled: false,
  sendButtonIcon: null,
  sendButtonTooltip: "",

  // Mic Button
  micButtonLoading: false,
  micButtonDisabled: false,
  micButtonIcon: null,
  micButtonTooltip: "",
  isRecording: false,
  micButtonType: "default",
  isMicButtonClicked: false,

  // Suggestions
  suggestions: [],
  suggestionsLoading: false,
  suggestionsError: null,
  isSuggestionsVisible: false,

  isNewChatClicked: false,

  // Grievance Registering Loading State
  isGrievanceRegistering: false,
  isVoiceMuteButtonVisible: false,
  isVoiceJourneyBgMuted: false,
  isVoiceProcessing: false,

  isBigMicButtonClicked: false,
  isTextFromBigMicButton: true,
  isSendTriggeredFromSocket:false,
};

const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    // Sidebar & Theme
    toggleSidebar: (state) => {
      state.isSidebarOpen = !state.isSidebarOpen;
    },
    toggleDarkMode: (state) => {
      state.isDarkMode = !state.isDarkMode;
    },

    // Input Bar
    setInputbarFocus: (state, action) => {
      state.isInputFocused = action.payload;
    },
    setInputDisabled: (state, action) => {
      state.isInputDisabled = action.payload;
    },
    setInputPlaceholder: (state, action) => {
      state.inputPlaceholder = action.payload;
    },
    setInputValue: (state, action) => {
      state.inputValue = action.payload;
    },
    clearInputValue: (state) => {
      state.inputValue = "";
    },
    setIsTyping: (state, action) => {
      state.isTyping = action.payload;
    },

    // Send Button
    setSendButtonLoading: (state, action) => {
      state.sendButtonLoading = action.payload;
    },
    setSendButtonDisabled: (state, action) => {
      state.sendButtonDisabled = action.payload;
    },
    setSendButtonIcon: (state, action) => {
      state.sendButtonIcon = action.payload;
    },
    setSendButtonTooltip: (state, action) => {
      state.sendButtonTooltip = action.payload;
    },
    resetSendButton: (state) => {
      state.sendButtonLoading = false;
      state.sendButtonDisabled = false;
      state.sendButtonIcon = null;
      state.sendButtonTooltip = "";
    },

    // Mic Button
    setMicButtonLoading: (state, action) => {
      state.micButtonLoading = action.payload;
    },
    setMicButtonDisabled: (state, action) => {
      state.micButtonDisabled = action.payload;
    },
    setMicButtonIcon: (state, action) => {
      state.micButtonIcon = action.payload;
    },
    setMicButtonTooltip: (state, action) => {
      state.micButtonTooltip = action.payload;
    },
    resetMicButton: (state) => {
      state.micButtonLoading = false;
      state.micButtonDisabled = false;
      state.micButtonIcon = null;
      state.micButtonTooltip = "";
      state.isRecording = false;
      state.micButtonType = "default";
    },
    setIsRecording: (state, action) => {
      state.isRecording = action.payload;
    },
    setMicButtonType: (state, action) => {
      state.micButtonType = action.payload;
    },

    // Suggestions
    setSuggestions: (state, action) => {
      state.suggestions = action.payload;
    },
    clearSuggestions: (state) => {
      state.suggestions = [];
    },
    setSuggestionsLoading: (state, action) => {
      state.suggestionsLoading = action.payload;
    },
    setSuggestionsError: (state, action) => {
      state.suggestionsError = action.payload;
    },
    setIsSuggestionsVisible: (state, action) => {
      state.isSuggestionsVisible = action.payload;
    },

    setIsMicButtonClicked: (state, action) => {
      state.isMicButtonClicked = action.payload;
    },

    setIsNewChatClicked: (state, action) => {
      state.isNewChatClicked = action.payload;
    },

    setIsGrievanceRegistering: (state, action) => {
      state.isGrievanceRegistering = action.payload;
    },
    setIsVoiceMuteButtonVisible: (state, action) => {
      state.isVoiceMuteButtonVisible = action.payload;
    },
    setIsVoiceJourneyBgMuted: (state, action) => {
      state.isVoiceJourneyBgMuted = action.payload;
    },
    setIsVoiceProcessing: (state, action) => {
      state.isVoiceProcessing = action.payload;
    },
    setIsBigMicButtonClicked: (state, action) => {
      state.isBigMicButtonClicked = action.payload;
    },
    setIsTextFromBigMicButton: (state, action) => {
      state.isTextFromBigMicButton = action.payload;
    },
    setIsSendTriggeredFromSocket: (state, action) => {
      state.isSendTriggeredFromSocket = action.payload;
    }
  },
});

export const {
  toggleSidebar,
  toggleDarkMode,
  setInputbarFocus,
  setInputDisabled,
  setInputPlaceholder,
  setInputValue,
  clearInputValue,
  setIsTyping,
  setSendButtonLoading,
  setSendButtonDisabled,
  setSendButtonIcon,
  setSendButtonTooltip,
  resetSendButton,
  setMicButtonLoading,
  setMicButtonDisabled,
  setMicButtonIcon,
  setMicButtonTooltip,
  resetMicButton,
  setIsRecording,
  setMicButtonType,
  setSuggestions,
  clearSuggestions,
  setSuggestionsLoading,
  setSuggestionsError,
  setIsSuggestionsVisible,
  setIsMicButtonClicked,
  setIsNewChatClicked,
  setIsGrievanceRegistering,
  setIsVoiceMuteButtonVisible,
  setIsVoiceJourneyBgMuted,
  setIsVoiceProcessing,
  setIsBigMicButtonClicked,
  setIsTextFromBigMicButton,
  setIsSendTriggeredFromSocket
} = uiSlice.actions;

export default uiSlice.reducer;
